import { msg } from '@gonfalon/messages/msg';
import { Box } from '@launchpad-ui/box';
import { ProgressBar } from '@launchpad-ui/components';

export function EnvironmentFallback() {
  return (
    <Box width="$256" height="$128" display="grid" alignItems="center" justifyContent="center">
      <ProgressBar aria-label={msg('chrome.status.loading')} isIndeterminate size="small" />
    </Box>
  );
}
